var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialReportCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4168 22.7087H7.58342C4.33342 22.7087 2.16675 21.0837 2.16675 17.292V9.70866C2.16675 5.91699 4.33342 4.29199 7.58342 4.29199H18.4168C21.6668 4.29199 23.8334 5.91699 23.8334 9.70866V17.292C23.8334 21.0837 21.6668 22.7087 18.4168 22.7087Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.75C14.7949 16.75 16.25 15.2949 16.25 13.5C16.25 11.7051 14.7949 10.25 13 10.25C11.2051 10.25 9.75 11.7051 9.75 13.5C9.75 15.2949 11.2051 16.75 13 16.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16675 10.2497H3.25008C6.50008 10.2497 7.58341 9.16634 7.58341 5.91634V4.83301",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8334 10.2497H22.7501C19.5001 10.2497 18.4167 9.16634 18.4167 5.91634V4.83301",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16675 16.75H3.25008C6.50008 16.75 7.58341 17.8333 7.58341 21.0833V22.1667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8334 16.75H22.7501C19.5001 16.75 18.4167 17.8333 18.4167 21.0833V22.1667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialReportCashIcon);
export default __webpack_public_path__ + "static/media/financial_report_cash_icon.51e37a5684e99b5412b7bb36c692810b.svg";
export { ForwardRef as ReactComponent };